import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Markup } from "interweave";
import { MainContext } from "../../context/main";
import { useNavLinks, usePostTags, useCurrentPost } from "../../hooks";
import { Title } from "..";
import EditTags from "./edit-tags";

export default function Page() {
  useCurrentPost();
  usePostTags();
  const { updateNavButtons } = useNavLinks();
  const { mainStore } = useContext(MainContext);

  useEffect(() => {
    if (mainStore.currentPost) {
      updateNavButtons({ nextCurrentPost: mainStore.currentPost });
    }
  }, [updateNavButtons, mainStore.currentPost]);

  return mainStore && mainStore.currentPost ? (
    <>
      <Title title={mainStore.currentPost.title} />
      <h1>
        {mainStore.currentPost.title}
        <Link to={`/edit/${mainStore.currentPost.id}`}>
          <button className="link-button">edit</button>
        </Link>
      </h1>
      <EditTags tags={mainStore.currentPost.tags || []} showDelete={false} />
      <Markup content={mainStore.currentPost.htmlContent} />
    </>
  ) : null;
}
